// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCOVgUAOXOcVNrZgXlTOleHbbV-XP9S5IQ",
  authDomain: "greenstar-pro-d3bc2.firebaseapp.com",
  projectId: "greenstar-pro-d3bc2",
  storageBucket: "greenstar-pro-d3bc2.appspot.com",
  messagingSenderId: "52262839195",
  appId: "1:52262839195:web:05dd253b3d126846fbb73e",
  measurementId: "G-N0SYNVRZW6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);